const paletteModal = document.getElementById("command-palette-modal");
const paletteInput = document.getElementById("command-palette-input");
const paletteResults = document.getElementById("command-palette-results");
const paletteClose = document.getElementById("command-palette-close");
const paletteTriggers = document.querySelectorAll("[data-command-palette-trigger]");
const commandDataElement = document.getElementById("command-palette-data");

if (paletteModal && paletteInput && paletteResults && commandDataElement) {
    let commands = [];
    let filteredCommands = [];
    let activeIndex = 0;

    try {
        commands = JSON.parse(commandDataElement.textContent || "[]");
    } catch (error) {
        console.error("Failed to parse command palette data:", error);
        commands = [];
    }

    const isTextInputTarget = (target) => {
        if (!target) {
            return false;
        }
        const tagName = (target.tagName || "").toLowerCase();
        return (
            tagName === "input" ||
            tagName === "textarea" ||
            tagName === "select" ||
            target.isContentEditable
        );
    };

    const scoreCommand = (command, query) => {
        const label = (command.label || "").toLowerCase();
        const keywords = (command.keywords || []).join(" ").toLowerCase();
        if (!query) {
            return 100000 - (command.order || 1000);
        }
        if (label.startsWith(query)) {
            return 10000 - label.length;
        }
        if (label.includes(query)) {
            return 5000 - label.indexOf(query);
        }
        if (keywords.includes(query)) {
            return 1000 - keywords.indexOf(query);
        }
        return -1;
    };

    const filterCommands = (queryValue) => {
        const query = (queryValue || "").trim().toLowerCase();
        filteredCommands = commands
            .map((command) => ({ command, score: scoreCommand(command, query) }))
            .filter((item) => item.score >= 0)
            .sort((left, right) => right.score - left.score || (left.command.order || 0) - (right.command.order || 0))
            .map((item) => item.command);
        activeIndex = 0;
    };

    const renderCommands = () => {
        if (!filteredCommands.length) {
            paletteResults.innerHTML = '<li class="px-4 py-3 text-sm text-gray-500 dark:text-chartmusic-textMuted">No matching commands.</li>';
            return;
        }

        paletteResults.innerHTML = filteredCommands
            .map((command, index) => {
                const section = command.section ? `<span class="text-xs text-gray-400 dark:text-chartmusic-textMuted">${command.section}</span>` : "";
                const activeClass = index === activeIndex
                    ? "bg-gray-100 dark:bg-chartmusic-surfaceElevated"
                    : "hover:bg-gray-50 dark:hover:bg-chartmusic-surfaceElevated";
                return `
                    <li>
                        <button type="button" data-command-index="${index}" class="flex items-center justify-between w-full px-4 py-3 text-left ${activeClass}">
                            <span class="text-sm text-gray-900 dark:text-chartmusic-text">${command.label}</span>
                            ${section}
                        </button>
                    </li>
                `;
            })
            .join("");
    };

    const openPalette = () => {
        filterCommands(paletteInput.value);
        renderCommands();
        paletteModal.classList.remove("hidden");
        paletteModal.classList.add("flex");
        paletteModal.setAttribute("aria-hidden", "false");
        paletteInput.focus();
        document.body.classList.add("overflow-hidden");
    };

    const closePalette = () => {
        paletteModal.classList.add("hidden");
        paletteModal.classList.remove("flex");
        paletteModal.setAttribute("aria-hidden", "true");
        document.body.classList.remove("overflow-hidden");
    };

    const goToActiveCommand = () => {
        const command = filteredCommands[activeIndex];
        if (command && command.url) {
            window.location.href = command.url;
        }
    };

    paletteTriggers.forEach((trigger) => {
        trigger.addEventListener("click", (event) => {
            event.preventDefault();
            openPalette();
        });
    });

    paletteInput.addEventListener("input", () => {
        filterCommands(paletteInput.value);
        renderCommands();
    });

    paletteResults.addEventListener("click", (event) => {
        const button = event.target.closest("button[data-command-index]");
        if (!button) {
            return;
        }
        activeIndex = Number(button.dataset.commandIndex || 0);
        goToActiveCommand();
    });

    if (paletteClose) {
        paletteClose.addEventListener("click", closePalette);
    }

    paletteModal.addEventListener("click", (event) => {
        if (event.target === paletteModal) {
            closePalette();
        }
    });

    document.addEventListener("keydown", (event) => {
        if ((event.metaKey || event.ctrlKey) && event.key.toLowerCase() === "k" && !isTextInputTarget(event.target)) {
            event.preventDefault();
            openPalette();
            return;
        }

        if (paletteModal.classList.contains("hidden")) {
            return;
        }

        if (event.key === "Escape") {
            event.preventDefault();
            closePalette();
            return;
        }
        if (!filteredCommands.length) {
            return;
        }

        if (event.key === "ArrowDown") {
            event.preventDefault();
            activeIndex = (activeIndex + 1) % filteredCommands.length;
            renderCommands();
        } else if (event.key === "ArrowUp") {
            event.preventDefault();
            activeIndex = (activeIndex - 1 + filteredCommands.length) % filteredCommands.length;
            renderCommands();
        } else if (event.key === "Enter") {
            event.preventDefault();
            goToActiveCommand();
        }
    });
}
